"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var notifications_service_1 = require("../notification/notifications.service");
var operators_1 = require("rxjs/operators");
var GridNotificationBarComponent = /** @class */ (function () {
    function GridNotificationBarComponent(notificationsService) {
        this.notificationsService = notificationsService;
    }
    GridNotificationBarComponent.prototype.ngOnInit = function () {
        this.notifications$ = this.notificationsService.getNotifications().pipe(operators_1.map(function (notifications) { return notifications.filter(function (notification) { return notification.originator === 'tickets'; }); }));
    };
    GridNotificationBarComponent.prototype.closeNotification = function (notification) {
        this.notificationsService.removeNotification(notification);
    };
    return GridNotificationBarComponent;
}());
exports.GridNotificationBarComponent = GridNotificationBarComponent;
